<template>
    <div>
        <Modal v-model="showStudentClassRecordModal" title="学员课程"  width="800">
            <Form ref="searchForm" :model="searchForm" inline
                  @keyup.enter.native="getList()">
                <FormItem prop="daterange" label="时间范围" :label-width="60">
                    <DatePicker :value="searchForm.daterange" type="daterange" split-panels placeholder="选择时间范围"
                                style="width: 240px"
                                format="yyyy-MM-dd" @on-change="searchForm.daterange=$event" :clearable="false"></DatePicker>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="getList" size="small">搜索</Button>
                </FormItem>
            </Form>
            <Table :columns="studentClassRecordColumns" :data="studentClassRecordData">
                <template slot-scope="{ row, index }" slot="state">
                    <div v-if="row.state==1"><Tag>未开始</Tag></div>
                    <div v-else-if="row.state==2"><Tag color="success">已结束</Tag></div>
                    <div v-else-if="row.state==3"><Tag color="warning">已取消</Tag><br>{{row.reason}}</div>
                    <div v-else-if="row.state==4"><Tag color="error">课时不足</Tag></div>
                    <div v-else>异常</div>
                </template>
                <template slot-scope="{ row, index }" slot="op">
                    <Button type="primary" size="small" @click="cancelClass(row.id)" v-if="row.state==1" style="margin-right: 5px;">取消</Button>
                </template>
            </Table>
            <div slot="footer"></div>
        </Modal>
        <cancelWin ref="cancelWin" @on-cancel-success="onCancelSuccess" :mode="2"></cancelWin>
    </div>
</template>

<script>
  import cancelWin from '../schedule/cancelWin'
  import moment from 'moment';
  moment.locale('zh-cn');

  export default {
    name: 'clazz_student_class_record',
    props: {
      clazzId: Number,
    },
    components: {
      cancelWin
    },
    data() {
      return {
        studentId:null,
        showStudentClassRecordModal:false,
        studentClassRecordColumns:[
          {
            title:'姓名',
            key:'name',
            align:'center'
          },
          {
            title:'日期',
            key:'date',
            align:'center'
          },
          {
            title:'时间',
            key:'time',
            align:'center'
          },
          {
            title:'状态',
            align:'center',
            slot:'state'
          },
          {
            title:'操作',
            align:'center',
            slot:'op'
          },
        ],
        studentClassRecordData:[],
        searchForm:{
          daterange: null,
        },
        showCancel:false,
        cancelForm:{
          reason:null,
          saving:false,
          id:null,
        },
        cancelFormValidate:{
          reason: [
            { required: true, message: '请输入取消原因', trigger: 'blur' }
          ],
        },
      }
    },
    methods: {
      showModal:function(studentId){
        this.studentId = studentId;
        this.searchForm.daterange = [
          moment(new Date()).subtract(15, 'days').format("YYYY-MM-DD"),
          moment(new Date()).add(30, 'days').format("YYYY-MM-DD")
        ],
        this.getList();
        this.showStudentClassRecordModal = true;
      },
      getList:function(){
        this.studentClassRecordData = [];
        this.$api.clazz.getStudentClassRecordList({
          clazzId: this.clazzId,
          studentId:this.studentId,
          start: this.searchForm.daterange[0],
          end: this.searchForm.daterange[1]
        }).then(res => {
          if (res.state == "ok") {
            this.studentClassRecordData = res.data;
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      cancelClass:function(id){
        this.$refs.cancelWin.showCancelWin(id);
      },
      onCancelSuccess(){
        this.getList();
      }
    },
    filters:{
    },
  }
</script>
